export default __webpack_public_path__ + "static/media/m5-1v2.85199604.png";